
import {
    GET_UPLOAD_ERRORS_REQUEST,
    GET_UPLOAD_ERRORS_SUCCESS,
    GET_UPLOAD_ERRORS_FAILURE,
} from "./uploadTableTypes";

const initialState = {
    loading: false,
    uploadErrorsData: [],
    error: "",
};

const getUploadErrorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_UPLOAD_ERRORS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_UPLOAD_ERRORS_SUCCESS:
            return {
                ...state,
                loading: false,
                uploadErrorsData: action.payload,
                error: "",
            };
        case GET_UPLOAD_ERRORS_FAILURE:
            return {
                ...state,
                loading: false,
                uploadErrorsData: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
 
export { getUploadErrorsReducer };